import { Box, IconButton } from "@mui/material";
import React, { useEffect, useRef } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CheckIcon from "@mui/icons-material/Check";
import { RequestDetailed } from "../../../../types/brm/request-types";
import "./styles.less";

type RequestDetailedHeaderStagesProps = {
    requestStages: {
        stage: string;
        text: string;
    }[];
    requestData: RequestDetailed | null;
};

const RequestDetailedHeaderStages: React.FC<RequestDetailedHeaderStagesProps> = ({ requestStages, requestData }) => {
    const activeTabIndex = requestStages.findIndex((stage) => stage.stage === requestData?.currentStage);

    const scrollRef = useRef<HTMLDivElement>(null);
    const activeTabRef = useRef<HTMLDivElement>(null);

    const scroll = (scrollOffset: number) => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: scrollOffset, behavior: "smooth" });
        }
    };

    useEffect(() => {
        if (activeTabRef.current && scrollRef.current) {
            const scrollBox = scrollRef.current;
            const activeTab = activeTabRef.current;
            const offsetLeft = activeTab.offsetLeft;
            const tabWidth = activeTab.offsetWidth;
            const scrollBoxWidth = scrollBox.offsetWidth;
            scrollBox.scrollTo({ left: offsetLeft - scrollBoxWidth / 2 + tabWidth / 2, behavior: "smooth" });
        }
    }, [activeTabIndex]);
    return (
        <Box className="request-stages-wrapper">
            <IconButton
                onClick={() => scroll(-300)}
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: 0,
                    transform: "translateY(-50%)",
                    zIndex: 2,
                    backgroundColor: "white",
                    width: "40px",
                    height: "48px",
                    borderRadius: "4px",
                    boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.2)",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                }}
            >
                <ArrowBackIosNewIcon sx={{ fontSize: "20px" }} />
            </IconButton>
            <IconButton
                onClick={() => scroll(300)}
                sx={{
                    position: "absolute",
                    top: "50%",
                    right: 0,
                    transform: "translateY(-50%)",
                    zIndex: 2,
                    backgroundColor: "white",
                    width: "40px",
                    height: "48px",
                    borderRadius: "4px",
                    boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.2)",
                    "&:hover": { backgroundColor: "#f0f0f0" },
                }}
            >
                <ArrowForwardIosIcon sx={{ fontSize: "20px" }} />
            </IconButton>
            <Box ref={scrollRef} className="stages-scroll-box">
                {requestStages.map((item, index) => {
                    const isActive = index === activeTabIndex;
                    const isLast = index === requestStages.length - 1;
                    const isFirst = index === 0;
                    const afterActive = index < activeTabIndex;

                    let stageClass = "stage-item";
                    if (isFirst) stageClass += " first";
                    if (isLast) stageClass += " last";
                    if (isActive) stageClass += " active";
                    if (afterActive) stageClass += " completed";

                    if (isActive && isLast) {
                        stageClass += " completed";
                    }

                    return (
                        <Box key={item.stage} className="stage-item-wrapper">
                            <Box className={stageClass} ref={isActive ? activeTabRef : undefined}>
                                {(afterActive || (isActive && isLast)) && <CheckIcon className="stage-check-icon" />}
                                {item.text}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
};

export default RequestDetailedHeaderStages;
